import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../App.css';
import SharedNavbar from '../components/SharedNavbar';
import Footer from '../components/Footer';

const BlogPage = () => {
    const [blogs, setBlogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    // Backend Base URL
    const BASE_URL = 'http://localhost:5000';

    useEffect(() => {
        const fetchBlogs = async () => {
            try {
                const response = await axios.get(`${ BASE_URL }/api/blogs`);
                if (response.data.success) {
                    setBlogs(response.data.data);
                } else {
                    setError('Failed to fetch blogs');
                }
            } catch (err) {
                console.error("Error fetching blogs:", err);
                setError('Error loading blogs. Please try again later.');
            } finally {
                setLoading(false);
            }
        };

        fetchBlogs();
    }, []);

    // Helper to get full image URL
    const getImageUrl = (imagePath) => {
        if (!imagePath) return 'https://via.placeholder.com/600x400?text=Moonshot';
        if (imagePath.startsWith('http')) return imagePath;
        return `${ BASE_URL }${ imagePath }`;
    };

    if (loading) {
        return (
            <div style={{ minHeight: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#fff', color: '#000' }}>
                <div className="spinner" style={{ border: '4px solid rgba(0,0,0,0.1)', borderLeftColor: '#000', borderRadius: '50%', width: '40px', height: '40px', animation: 'spin 1s linear infinite' }}></div>
                <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
            </div>
        );
    }

    return (
        <div style={{ position: 'relative', minHeight: '100vh', display: 'flex', flexDirection: 'column', backgroundColor: '#fff' }}>

            <div style={{ position: 'relative', zIndex: 1, display: 'flex', flexDirection: 'column', flex: 1 }}>
                <SharedNavbar activePage="blog" />

                <div style={{ flex: 1, padding: '140px 5% 80px', maxWidth: '1400px', margin: '0 auto', width: '100%' }}>
                    <div style={{ textAlign: 'center', marginBottom: '80px', animation: 'fadeInUp 0.8s ease-out' }}>
                        <h1 style={{
                            color: '#000',
                            fontSize: '4rem',
                            fontWeight: '800',
                            marginBottom: '20px',
                            background: 'linear-gradient(135deg, #000 0%, #444 100%)',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent',
                            letterSpacing: '-2px',
                            lineHeight: 1
                        }}>
                            Moonshot Insights
                        </h1>
                        <p style={{ color: 'rgba(0,0,0,0.7)', fontSize: '1.2rem', maxWidth: '600px', margin: '0 auto', lineHeight: 1.6 }}>
                            Strategies, frameworks, and deep dives for founders building the future.
                        </p>
                    </div>

                    {error ? (
                        <div style={{ textAlign: 'center', color: '#ff6b6b', background: 'rgba(255,0,0,0.05)', padding: '20px', borderRadius: '12px' }}>{error}</div>
                    ) : blogs.length === 0 ? (
                        <div style={{ textAlign: 'center', color: 'rgba(0,0,0,0.5)', marginTop: '80px' }}>
                            <p>No insights published yet. Check back soon.</p>
                        </div>
                    ) : (
                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(auto-fill, minmax(380px, 1fr))',
                            gap: '40px',
                            animation: 'fadeInUp 1s ease-out'
                        }}>
                            {blogs.map((blog, index) => (
                                <div
                                    key={blog._id}
                                    onClick={() => navigate(`/blog/${ blog.slug }`)}
                                    style={{
                                        position: 'relative',
                                        borderRadius: '24px',
                                        overflow: 'hidden',
                                        cursor: 'pointer',
                                        aspectRatio: '4/3',
                                        backgroundColor: '#fff',
                                        border: '1px solid rgba(0,0,0,0.08)',
                                        transition: 'all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
                                        boxShadow: '0 10px 30px -10px rgba(0,0,0,0.1)',
                                    }}
                                    className="blog-card"
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = 'translateY(-10px)';
                                        e.currentTarget.style.boxShadow = '0 20px 40px -10px rgba(0, 0, 0, 0.15)';
                                        e.currentTarget.style.borderColor = 'rgba(0,0,0,0.15)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = 'translateY(0)';
                                        e.currentTarget.style.boxShadow = '0 10px 30px -10px rgba(0,0,0,0.1)';
                                        e.currentTarget.style.borderColor = 'rgba(0,0,0,0.08)';
                                    }}
                                >
                                    {/* Image Container */}
                                    <div style={{ height: '60%', width: '100%', position: 'relative', overflow: 'hidden' }}>
                                        <img
                                            src={getImageUrl(blog.coverImage)}
                                            alt={blog.title}
                                            style={{
                                                width: '100%',
                                                height: '100%',
                                                objectFit: 'cover',
                                                transition: 'transform 0.5s ease'
                                            }}
                                        />
                                    </div>

                                    {/* Content */}
                                    <div style={{
                                        position: 'absolute',
                                        bottom: 0,
                                        left: 0,
                                        right: 0,
                                        padding: '24px',
                                        background: '#fff',
                                        height: '40%',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'space-between',
                                        borderTop: '1px solid rgba(0,0,0,0.05)'
                                    }}>
                                        {/* Tags & Date */}
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                                            <span style={{
                                                background: 'rgba(0,0,0,0.05)',
                                                padding: '4px 12px',
                                                borderRadius: '100px',
                                                fontSize: '0.75rem',
                                                fontWeight: '600',
                                                color: '#000',
                                                textTransform: 'uppercase',
                                                letterSpacing: '0.05em'
                                            }}>
                                                {blog.tags?.[0] || 'Article'}
                                            </span>
                                            <span style={{ fontSize: '0.8rem', color: 'rgba(0,0,0,0.5)' }}>
                                                {new Date(blog.createdAt).toLocaleDateString(undefined, { month: 'short', day: 'numeric' })}
                                            </span>
                                        </div>

                                        {/* Title */}
                                        <h3 style={{
                                            color: '#000',
                                            fontSize: '1.25rem',
                                            fontWeight: '700',
                                            lineHeight: '1.3',
                                            margin: '0',
                                            display: '-webkit-box',
                                            WebkitLineClamp: 2,
                                            WebkitBoxOrient: 'vertical',
                                            overflow: 'hidden'
                                        }}>
                                            {blog.title}
                                        </h3>

                                        {/* Read More Link */}
                                        <div style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '6px',
                                            color: '#000',
                                            fontSize: '0.9rem',
                                            fontWeight: '600',
                                            marginTop: 'auto'
                                        }}>
                                            Read Article
                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                                                <path d="M5 12h14m-7-7l7 7-7 7" />
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                <Footer />
            </div>
        </div>
    );
};

export default BlogPage;
